export default "__VITE_ASSET__DvaZgZGi__"